export default __webpack_public_path__ + "static/media/shopCategory-3.da971be8.png";